import { Component, ViewEncapsulation, inject } from "@angular/core";
import { CompProductFacade } from "../../services/comp-product-facade";
import { ProductFacade } from "../../services/product-facade";
import {
  StepperComponent,
  StepperStepTemplateDirective,
} from "@progress/kendo-angular-layout";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { GlobalStateService } from "../../../services/global-state.service";

@Component({
  selector: "app-product-stepper",
  templateUrl: "./product-stepper.component.html",
  styleUrls: ["./product-stepper.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [
    StepperComponent,
    StepperStepTemplateDirective,
    AsyncPipe,
    TranslateModule,
  ],
})
export class ProductStepperComponent {
  productFacade = inject(ProductFacade);
  private compProductFacade = inject(CompProductFacade);
  private globalStateSvc = inject(GlobalStateService);

  private _currentStep = 0;

  public get currentStep(): number {
    return this._currentStep;
  }
  public set currentStep(value: number) {
    this._currentStep = value;
  }

  constructor() {
    const productFacade = this.productFacade;

    productFacade.currentStepNumber$.subscribe((r) => {
      this.currentStep = r;
    });
  }

  public setCurrentStep(e: number): void {
    this.productFacade.revertStepTo(e);
    this.compProductFacade.hideCompProduct();
    this.compProductFacade.resetState();
  }

  public goToQtyStep() {
    this.compProductFacade.hideCompProduct();
    this.productFacade.goToQtyStep();
  }
}
